import React from 'react'

function SVGIcon (props) {
  const fillColor = props.fill ? props.fill : '#D14142'
  const classNames = props.className ? props.className : null

  switch (props.type) {
    case 'checkmark':
      return (<svg className={classNames} width="16" height="16" viewBox="0 0 16 16">
        <path
          d="M425,2034a8,8,0,1,0,8,8A8,8,0,0,0,425,2034Zm-1.5,12.031-2.813-3.344,1.031-1.031,1.781,1.75,5.156-4.5.719.719-5.875,6.406Z"
          transform="translate(-417 -2033.999)" fill={fillColor}/>
      </svg>)
    case 'delete':
      return (<svg className={classNames} width="16" height="16" viewBox="0 0 16 16">
        <path
          d="M169,1682a8,8,0,1,0,8,8A8,8,0,0,0,169,1682Zm4,10.5-1.5,1.5-2.5-2.5-2.5,2.5-1.5-1.5,2.5-2.5-2.5-2.5,1.5-1.5,2.5,2.5,2.5-2.5,1.5,1.5-2.5,2.5Z"
          transform="translate(-161 -1681.999)" fill={fillColor}/>
      </svg>)
    case 'add':
      return (<svg className={classNames} width="16" height="16" viewBox="0 0 16 16">
        <path d="M777,1650a8,8,0,1,0,8,8A8,8,0,0,0,777,1650Zm1,9v4h-2v-4h-4v-2h4v-4h2v4h4v2Z"
              transform="translate(-769 -1649.999)" fill={fillColor}/>
      </svg>)
    case 'add-alt':
      return (<svg className={classNames} width="16" height="16" viewBox="0 0 16 16">
        <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,15.2A7.2,7.2,0,1,1,15.2,8,7.2,7.2,0,0,1,8,15.2Z" fill={fillColor}/>
        <path d="M11,7.5H8.5V5a.5.5,0,0,0-1,0V7.5H5a.5.5,0,0,0,0,1H7.5V11a.5.5,0,0,0,1,0V8.5H11a.5.5,0,0,0,0-1Z"
              fill={fillColor}/>
      </svg>)
    case 'remove-alt':
      return (<svg className={classNames} viewBox="0 0 16 16">
        <path fill={fillColor} d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,15.2A7.2,7.2,0,1,1,15.2,8,7.2,7.2,0,0,1,8,15.2Z"/>
        <path fill={fillColor} d="M11,8.5H5a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z"/>
      </svg>)
    case 'info':
      return (<svg className={classNames} width="16" height="16" viewBox="0 0 16 16">
        <path
          d="M105,1682a8,8,0,1,0,8,8A8,8,0,0,0,105,1682Zm-1,3.75a.752.752,0,0,1,.75-.75h.5a.752.752,0,0,1,.75.75v.5a.753.753,0,0,1-.75.75h-.5a.753.753,0,0,1-.75-.75Zm3,9.25h-4v-1h1v-4h-1v-1h3v5h1Z"
          transform="translate(-97 -1681.999)" fill={fillColor}/>
      </svg>)
    case 'edit':
      return (<svg className={classNames} x="0px" y="0px" viewBox="0 0 512 512">
        <polygon points="51.2,353.28 0,512 158.72,460.8" fill={fillColor}/>
        <rect x="89.73" y="169.097" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -95.8575 260.3719)" width="353.277"
              height="153.599" fill={fillColor}/>
        <path
          d="M504.32,79.36L432.64,7.68c-10.24-10.24-25.6-10.24-35.84,0l-23.04,23.04l107.52,107.52l23.04-23.04 C514.56,104.96,514.56,89.6,504.32,79.36z"
          fill={fillColor}/>
      </svg>)
    case 'arrow-up':
      return (<svg className={classNames} width="12" height="7.5" viewBox="0 0 12 7.5">
        <path d="M481,1786.5l1.5,1.5,4.5-4.5,4.5,4.5,1.5-1.5-6-6Z" transform="translate(-481 -1780.499)"
              fill={fillColor}/>
      </svg>)
    case 'calendar':
      return (<svg className={classNames} width="15" height="16" viewBox="0 0 15 16">
        <path
          d="M582,632h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm-9,6h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm-3-3h2v2h-2Zm3,0h2v2h-2Zm3,0h2v2h-2Zm-9,0h2v2h-2Zm11-9v1h-2v-1h-7v1h-2v-1h-2v16h15V626Zm1,15H578V630h13Z"
          transform="translate(-577 -625.999)" fill={fillColor}/>
      </svg>)
    case 'arrow-right':
      return (<svg className={classNames} viewBox="0 0 6.75 10.9">
        <polygon points="0.81 10.9 0 10.02 4.98 5.45 0 0.89 0.81 0 6.75 5.45 0.81 10.9" fill={fillColor}/>
      </svg>)
    case 'close':
      return (<svg className={classNames} x="0px" y="0px" viewBox="0 0 512.001 512.001">
        <path
          d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285L284.286,256.002z"
          fill={fillColor}/>
      </svg>)
    case 'close-circle':
      return (<svg className={classNames} viewBox="0 0 16 16">
        <path fill={fillColor}
              d="M13.66,2.34a8,8,0,1,0,0,11.32A8,8,0,0,0,13.66,2.34ZM2.91,13.09a7.2,7.2,0,1,1,10.18,0,7.2,7.2,0,0,1-10.18,0Z"/>
        <path fill={fillColor}
              d="M8.71,8l1.76-1.77a.5.5,0,0,0,0-.71.5.5,0,0,0-.7,0L8,7.29,6.23,5.52a.5.5,0,0,0-.7,0,.5.5,0,0,0,0,.71L7.29,8,5.52,9.77a.5.5,0,0,0,0,.7.5.5,0,0,0,.71,0L8,8.71l1.77,1.76a.49.49,0,1,0,.7-.7Z"/>
      </svg>)
    case 'warning':
      return (<svg className={classNames} width="31.999" height="32" viewBox="0 0 31.999 32">
        <path
          d="M256.56,1678.617h0L242.9,1651.4a1.994,1.994,0,0,0-3.8,0l-13.658,27.222c-1.046,1.86-.156,3.382,1.978,3.382h27.166c2.134,0,3.024-1.522,1.978-3.382ZM241,1678a2,2,0,1,1,2-2A2,2,0,0,1,241,1678Zm2-8a2,2,0,0,1-4,0v-6a2,2,0,0,1,4,0Z"
          transform="translate(-225.002 -1649.999)" fill={fillColor}/>
      </svg>)
    default:
      return null
  }
}

export default SVGIcon